module.exports = __webpack_public_path__ + "static/media/promo.86f3e719.png";